
import { PrimaryVariant } from './components/primary'
import { SecondaryVariant } from './components/secondary'
import { TertiaryVariant } from './components/tertiary'
import { PrimaryProps } from './types'

export const CustomModal: React.FC<PrimaryProps> = ({
  type = 'primary',
  title,
  ...props
}) => {
  return (
    <>
      {type === 'primary' ?
        <PrimaryVariant {...props} title={title} />
      : type === 'tertiary' ?
        <TertiaryVariant title={title} {...props}/>
        :
        <SecondaryVariant title={title} />
      }
    </>
  )
}
